import u from "./index205.mjs";
import a from "./index212.mjs";
function o(t) {
  a(1, arguments);
  var e = u(t), r = e.getMinutes();
  return r;
}
export {
  o as default
};
//# sourceMappingURL=index267.mjs.map
